module.exports = __webpack_public_path__ + "static/14-56ea87c19768d507a1717d1734f1609c.webp";